import { call, put, takeLatest } from 'redux-saga/effects';

import { fetchReportDataApi } from '../../api';
import {
  fetchReportData,
  reportDataSuccess,
  reportDataError,
} from '../slices/reportSlice';

function* fetchReportDataWorker(action) {
  try {
    const { status, ok, data } = yield call(fetchReportDataApi, action.payload);

    if (ok) {
      yield put(reportDataSuccess(data));
    } else {
      yield put(reportDataError({ status, data }));
    }
  } catch (err) {
    yield put(reportDataError(err.message));
    throw new Error(`Error: ${err.message}`);
  }
}

export default function* reportSaga() {
  yield takeLatest(fetchReportData.type, fetchReportDataWorker);
}
